"use client"

import Image from "next/image";
import { useState } from "react";



export default function article() {

    const articleData = [
        {
            images: '/img/tips-img.png',
            title: 'Top 5 Tips for Efficient PDF Editing',
            description: 'Are you tired of spending too much time on PDF tasks? Check out our top tips for streamlining your PDF management process and saving valuable time.'
        },
        {
            images: '/img/benefits-img.png',
            title: 'The Benefits of UsePDF for Students',
            description: 'Being a student often means juggling multiple assignments and projects. Discover how a PDF editor can make your academic life easier and more organized.'
        },
        {
            images: '/img/protecting-img.png',
            title: 'Protecting Your PDFs: A Complete Guide',
            description: 'Security is crucial when dealing with sensitive documents. Learn the best practices for protecting your PDFs from unauthorized access and potential threats.'
        }

    ];

    return (
        // <div classNameName="container mx-auto py-10">
        //     <h1 classNameName="text-3xl font-bold text-center mb-2">Discover all you need right here</h1>
        //     <p classNameName="text-center mb-8">Your questions, our answers</p>

        //     <div classNameName="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        //         {articleData.map((article: any) => (
        //             <>
        //                 <div classNameName="bg-white p-6 rounded-lg shadow-md">
        //                     <img classNameName="w-full h-48 object-cover rounded-t-lg" src={article.images} alt="Tips for Efficient PDF Editing" />
        //                     <h2 classNameName="text-xl text-center font-semibold mt-5">{article.title}</h2>
        //                     <p classNameName="mt-3 text-center">{article.description}</p>
        //                     <div classNameName="flex justify-center mt-4">
        //                         <button classNameName="bg-yellow-500 text-white py-2 px-4 rounded-full hover:bg-yellow-600">Discover More</button>
        //                     </div>
        //                 </div>
        //             </>
        //         ))}
        //     </div>
        // </div>

        <section className="discover section-gap w-full bg-neutral-300" id="Blogs">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="content-box text-center">
                            <h2 className="main-heading">Discover all you need right here</h2>
                            <p className="content-box__desc sub-desc fs-2">Your questions, our answers</p>
                        </div>

                        <div className="discover__wrapper grid grid--md-2 grid--lg-3 grid--1 gap-md-250 gap-150">
                            {articleData.map((article: any) => (
                                <>
                                    <div className="discover__box box-shadow d-flex flex-column align-items-center">
                                        <div className="d-flex justify-content-center mb-300">
                                            <img className="img-fluid" src={article.images} alt="img" />
                                        </div>
                                        <div className="content-box text-center">
                                            <h5 className="sub-heading lg:min-h-[50px] 2xl:min-h-[50px] xl:min-h-[50px] md:min-h-[50px] sm:min-h-[23px] min-h-[23px]">{article.title}</h5>
                                            <p className="content-box__desc fs-4 fw-normal  md:min-h-[90px] lg:min-h-[90px] ">{article.description}</p>
                                        </div>
                                        <button className="mybtn mybtn--warning mt-200 mt-md-400 fw-normal">DISCOVER MORE</button>
                                    </div>
                                </>
                            ))}


                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
